import React, {Component} from 'react';
import {getUserBalance} from "../../../services/state-management/actions/common/users/UsersActions";
import {connect} from "react-redux";
import PropTypes from 'prop-types'
import {fetchUser} from "../../../services/state-management/actions/auth/AuthActions";
import Helper from "../../util/Helper";

class Balance extends Component {

    componentDidMount() {

        this.props.getUserBalance();
        this.props.fetchUser();

    };

    static propTypes = {

        getUserBalance: PropTypes.func.isRequired,
        wallet: PropTypes.string.isRequired,
        fetchUser: PropTypes.func.isRequired

    };

    checkPlan = () => {

        const {plan} = this.props.user;
        const {wallet} = this.props;

        if(plan){
            switch (plan.name) {
                case "Basic unlimited plan":
                    return <b>Unlimited</b>;

                default:
                    return <b>{typeof (wallet) == "string" ? Helper.formatCurrency(wallet) : null}</b>

            }

        } else return null

    };

    render() {

        return (
            <div className="wallet-balance col-md-2">
                <div className="icon pr-2">
                    <img src="https://res.cloudinary.com/teewhy/image/upload/v1546529222/customerportal-balance.fw.png" alt="images"/>
                </div>

                <div>
                    <h5 className="count mt-1">
                        <span className="saving">
                            {this.checkPlan()}
                        </span>
                        <br />
                        <span className="baby-font">Balance</span></h5>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({

    wallet: state.wallet.wallet,
    user: state.auth.auth

});

export default connect(mapStateToProps, {getUserBalance, fetchUser})(Balance);